(function () {
  function getCards(root, selector) {
    return Array.prototype.slice.call(
      root.querySelectorAll(selector)
    );
  }

  function getNearestIndex(viewport, cards) {
    var currentScroll = viewport.scrollLeft;
    var nearestIndex = 0;
    var nearestDistance = Infinity;

    cards.forEach(function (card, index) {
      var distance = Math.abs(card.offsetLeft - currentScroll);

      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  function scrollToCard(viewport, card, behavior) {
    if (!card) {
      return;
    }

    viewport.scrollTo({
      left: card.offsetLeft,
      behavior: behavior || 'smooth'
    });
  }

  function initSection(root) {
    if (!root || root.dataset.showcaseReady === 'true') {
      return;
    }

    var viewport = root.querySelector('[data-showcase-viewport]');
    var prevButton = root.querySelector('[data-showcase-prev]');
    var nextButton = root.querySelector('[data-showcase-next]');
    var cards = getCards(root, '.wo_active_showcase__card');
    var realCards = getCards(root, '.wo_active_showcase__card:not(.wo_active_showcase__card--clone)');
    var realCount = realCards.length;
    var normalizeTimer = null;

    if (!viewport || !prevButton || !nextButton || !cards.length || !realCount) {
      return;
    }

    function getLoopSpan() {
      return realCards[0].offsetLeft - cards[0].offsetLeft;
    }

    function getTrailingSetStart() {
      return cards[realCount * 2];
    }

    function normalizePosition() {
      var loopSpan = getLoopSpan();
      var firstRealCard = realCards[0];
      var trailingSetStart = getTrailingSetStart();
      var epsilon = 2;

      if (!loopSpan || !firstRealCard || !trailingSetStart) {
        return;
      }

      if (viewport.scrollLeft < firstRealCard.offsetLeft - epsilon) {
        viewport.scrollLeft += loopSpan;
      } else if (viewport.scrollLeft >= trailingSetStart.offsetLeft - epsilon) {
        viewport.scrollLeft -= loopSpan;
      }
    }

    function scheduleNormalize() {
      window.clearTimeout(normalizeTimer);
      normalizeTimer = window.setTimeout(normalizePosition, 220);
    }

    function handleClick(direction) {
      var currentIndex = getNearestIndex(viewport, cards);
      var targetIndex = currentIndex + direction;

      if (targetIndex < 0) {
        targetIndex = cards.length - 1;
      } else if (targetIndex >= cards.length) {
        targetIndex = 0;
      }

      scrollToCard(viewport, cards[targetIndex]);
      scheduleNormalize();
    }

    prevButton.addEventListener('click', function () {
      handleClick(-1);
    });

    nextButton.addEventListener('click', function () {
      handleClick(1);
    });

    viewport.addEventListener('scroll', function () {
      scheduleNormalize();
    }, { passive: true });

    window.addEventListener('resize', function () {
      normalizePosition();
    });

    scrollToCard(viewport, realCards[0], 'auto');
    normalizePosition();
    root.dataset.showcaseReady = 'true';
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.wo_active_showcase');

    roots.forEach(function (root) {
      initSection(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
